import React from 'react';

import styles from './styled-strips.module.scss';
export const Cell = ({ className, ...props }: React.ComponentPropsWithoutRef<'td'>) => (
  <td className={className ? `${styles['cell']} ${className}` : styles['cell']} {...props} />
);

export const BaseRow = ({ className, ...props }: React.ComponentPropsWithoutRef<'tr'>) => (
  <tr
    className={className ? `${styles['base-row']} ${className}` : styles['base-row']}
    {...props}
  />
);

export const BlockContainer = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={className ? `${styles['block-container']} ${className}` : styles['block-container']}
    {...props}
  />
);

export const BaseBlock = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={className ? `${styles['base-block']} ${className}` : styles['base-block']}
    {...props}
  />
);

export const OrderIndicator = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={className ? `${styles['order-indicator']} ${className}` : styles['order-indicator']}
    {...props}
  />
);

export const Image = ({ className, ...props }: React.ComponentPropsWithoutRef<'img'>) => (
  <img className={className ? `${styles['image']} ${className}` : styles['image']} {...props} />
);

export const CoverItem = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={className ? `${styles['cover-item']} ${className}` : styles['cover-item']}
    {...props}
  />
);

export const HiddenCoverOverlay = ({
  className,
  ...props
}: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={
      className ? `${styles['hidden-cover-overlay']} ${className}` : styles['hidden-cover-overlay']
    }
    {...props}
  />
);

export const RowMirror = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={className ? `${styles['row-mirror']} ${className}` : styles['row-mirror']}
    {...props}
  />
);
